import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useRequest } from 'hooks';

import Modal from 'components/Modal';
import { Button, Datepicker } from 'components/Misc/Form';

const Update = ({ modal, onModal, refresh }) => {
	// Store current object's id
	const { id } = useParams();

	// Store request
	const [[progress], request] = useRequest('put', `courses/${id}`);

	// Store update state
	const [data, setData] = useState({
		startDate: '',
		endDate: ''
	});

	// Handle date change
	const onChange = ({ name, value }) => {
		setData(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Handle student assignment
	const onSubmit = async event => {
		event.preventDefault();

		// Try to assign students
		const [success] = await request(data, {
			related: 'students:unassigned'
		});

		// Recollect student list on successful update
		if (success) await refresh();
	};

	return (
		<Modal title="Pievienot pārbaudes darbu" visible={modal} handleModal={onModal}>
			<div className="space-y-4">
				<div className="grid grid-cols-2 gap-4">
					<Datepicker
						asInput
						label="Sākuma datums"
						name="startDate"
						value={data.startDate}
						onChange={onChange}
					/>

					<Datepicker
						end
						asInput
						label="Beigu datums"
						name="endDate"
						value={data.endDate}
						onChange={onChange}
					/>
				</div>

				<div className="flex justify-end">
					<Button
						value="Pievienot"
						onClick={onSubmit}
						progress={progress}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default Update;